(() => {
  angular
    .module('finance')
    .controller('finance.views.manualTransactionRequests.editIrbmMyInvoisSettingsModal', EditIrbmMyInvoisSettingsModalController);

  EditIrbmMyInvoisSettingsModalController.$inject = [
    '$uibModalInstance',
    'billingAccountId',
    'tenantId',
    'subsidiaryId',
    'countryCode',
    'isCreate'
  ];

  function EditIrbmMyInvoisSettingsModalController(
    $uibModalInstance,
    billingAccountId,
    tenantId,
    subsidiaryId,
    countryCode,
    isCreate
  ) {
    const vm = this;

    vm.save = save;
    vm.close = close;

    vm.billingAccountId = billingAccountId;
    vm.tenantId = tenantId;
    vm.subsidiaryId = subsidiaryId;
    vm.countryCode = countryCode;
    vm.isCreate = isCreate;
    vm.editIrbmMyInvoisSettingsWidget = null;

    function save() {
      if (!vm.hasMalaysiaTaxIdentifier 
        && vm.countryCode === 'MY' 
        && vm.editIrbmMyInvoisSettingsWidget != null) 
      setTaxIdentifiers(vm.billingAccountId);
    }

    function close() {
      vm.editIrbmMyInvoisSettingsWidget = null;
      $uibModalInstance.dismiss();
    }
    
    function setTaxIdentifiers() {
      const payload = vm.editIrbmMyInvoisSettingsWidget.taxIdentifiers[0];

      // Throw error on empty tax identifiers.

      if (payload.taxIdentificationNumber == null 
        || payload.taxIdentificationNumber == undefined
        || payload.taxIdentificationNumber == '') {
          abp.notify.error(App.localize('TaxIdentifiersInvalidFormInputError'));
          return;
      }

      payload.tenantIdentityServerId = tenantId;
      payload.subsidiaryId = subsidiaryId;
      payload.billingAccountId = billingAccountId;

      vm.editIrbmMyInvoisSettingsWidget.validateForm();
      if (!vm.editIrbmMyInvoisSettingsWidget.irbmMyInvoisSettingsEditForm.$invalid)
        $uibModalInstance.close();
    }
  }
})();
